import { FC } from 'react';
import { DataSourceFileConfig, TDataSource } from '@/models/dataSource';
import { FileElementsPreview } from './overview/file';

type FileDataSourceDataProps = {
  dataSource?: TDataSource<DataSourceFileConfig>;
};

export const FileDataSourceData: FC<FileDataSourceDataProps> = ({ dataSource }) => {
  const url = dataSource?.configuration.url;
  const fileName = url?.substring(url.lastIndexOf('/') + 1);

  return (
    <div className='flex flex-col overflow-hidden bg-white-100 shadow sm:rounded-b-md'>
      {fileName && (
        <div className='px-6 py-5'>
          <p className='text-lg font-semibold text-primary-900'>{fileName}</p>
        </div>
      )}
      <FileElementsPreview dataSource={dataSource} />
    </div>
  );
};
